import { HomeIcon, RoadIcon, RoadworkIcon } from "@l2r-front/l2r-icons"
import { LINEAR_ABSOLUTE_END_URL_PARAM, LINEAR_ABSOLUTE_START_URL_PARAM } from "@l2r-front/l2r-networks"

import { L2rAppRoad } from "../../app"
import { NotationEPDKpi } from "../../modules/roadway/containers/NotationEPDKpi"
import { NotationTrendingKpi } from "../../modules/roadway/containers/NotationTrendingKpi"
import { SELECTED_TECHNIQUE_URL_PARAM } from "../../modules/roadworks/constants/techniques"
import { RoadworksBudgetsKpi } from "../../modules/roadworks/containers/RoadworksBudgetsKpi/RoadworksBudgetsKpi"
import { RoadworksYearlyBudgetKpi } from "../../modules/roadworks/containers/RoadworksYearlyBudgetKpi"

import { I18N_NAMESPACE } from "./i18n"
import { MODULE_DASHBOARD, MODULE_ROADWAY, MODULE_ROADWORKS } from "./modules"
import { NETWORK_ASSESMENT_TYPE_URL_PARAM } from "./urlParams"

export const APP_ROAD = "road"
export const API_MODULE_ROADWAY = "ROADWAY"
export const API_MODULE_MIRANDA = "MIRANDA"

export const appRoad = {
    index: 1,
    color: "cta-bg/cta-bg-primary",
    component: <L2rAppRoad />,
    icon: RoadIcon,
    externalContexts: [],
    i18nNamespace: I18N_NAMESPACE,
    label: "app.label",
    modules: {
        dashboard: {
            index: 0,
            id: "DASHBOARD",
            label: "app.modules.dashboard",
            path: MODULE_DASHBOARD,
            icon: HomeIcon,
            mandatoryModules: [API_MODULE_ROADWAY],
            alwaysShowIcon: true,
            hidePopover: true,
        },
        roadway: {
            enablersModules: [API_MODULE_MIRANDA, API_MODULE_ROADWAY],
            index: 1,
            icon: RoadIcon,
            id: API_MODULE_ROADWAY,
            kpis: [{
                component: NotationEPDKpi,
                mobileOrder: 1,
                parent: "sidebar",
                position: 1,
            },
            {
                component: NotationTrendingKpi,
                gridIndex: 1,
                mobileHeight: 470,
                mobileOrder: 3,
                height: "100%",
                parent: "list",
            }],
            label: "app.modules.roadway",
            path: MODULE_ROADWAY,
            urlParams: [LINEAR_ABSOLUTE_START_URL_PARAM, LINEAR_ABSOLUTE_END_URL_PARAM, NETWORK_ASSESMENT_TYPE_URL_PARAM],
        },
        roadworks: {
            index: 2,
            icon: RoadworkIcon,
            id: "ROADWORK",
            kpis: [{
                component: RoadworksBudgetsKpi,
                gridIndex: 0,
                height: "100%",
                mobileHeight: 470,
                mobileOrder: 2,
                parent: "list",
            },
            {
                component: RoadworksYearlyBudgetKpi,
                gridIndex: 2,
                height: "100%",
                mobileHeight: "fit-content",
                mobileOrder: 4,
                parent: "list",
            }],
            label: "app.modules.works",
            path: MODULE_ROADWORKS,
            urlParams: [LINEAR_ABSOLUTE_START_URL_PARAM, LINEAR_ABSOLUTE_END_URL_PARAM, SELECTED_TECHNIQUE_URL_PARAM],
        },
    },
    path: APP_ROAD,
}